export const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';
